import { OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { useUserData } from '@/User/ui/context'

export const Step1NoPhones = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()
  return (
    <OreText>
      {!merchant.isNursery ? t(contractTranslation.changeBankAccount.step1.noPhones, {
        CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL
      }) : t(contractTranslation.changeBankAccount.step1.noPhonesGuarderia)}
      {merchant.isNursery ? <strong>{t(contractTranslation.changeBankAccount.step1.noPhonesGuarderiaEmail)}</strong> : null}
    </OreText>
  )
}
